import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isEmpty } from 'lodash';
import Collection from 'components/Collection';
import { hideModal, showModal } from 'actions/modal';
import { navigateToPlayerPage } from 'actions/player';
import { fetchDetails } from 'actions/details';
import { navigateToAuthPage } from 'actions/app';
import { CONTENT_TYPES } from 'constants/content-types';
import Platform from 'platform';
import {
  selectBackButtonKeyCode,
  selectCollectionId,
  selectCollectionTitle,
  selectContentIdFromProps,
  selectContentTypeFromProps,
  selectParentalControl,
  selectSeasons,
} from 'pages/Seasons/selectors';
import withKeepingLastFocus from 'components/HOCs/withKeepingLastFocus';
import useContentNavigation from 'hooks/useContentNavigation';

const CONTENT_TYPE_TO_URL = {
  [CONTENT_TYPES.VOD_ASSET]: 'asset',
  [CONTENT_TYPES.TV_SERIES]: 'tvSeries',
};

const LAST_FOCUS_KEY = 'seasons';

const SeasonsPageContainer = (props) => {
  const { fetchDetails, contentId, contentType, data, lastFocusKeeper } = props;
  const onContentEnter = useContentNavigation();

  const handleEnter = useCallback(
    (item, { itemId } = {}) => {
      if (itemId) lastFocusKeeper.save(LAST_FOCUS_KEY, `#${itemId}`);
      onContentEnter(item, { elementToFocus: `#${itemId}` });
    },
    [lastFocusKeeper, onContentEnter],
  );

  useEffect(() => {
    fetchDetails(contentId, CONTENT_TYPE_TO_URL[contentType], true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // TODO: it's not workign rigth now, because "fetchDetails" works on every mount
  useEffect(() => {
    const lastFocus = lastFocusKeeper.select(LAST_FOCUS_KEY);
    if (lastFocus.hasSaved()) lastFocus.apply(lastFocus.reset);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isEmpty(data) ? null : <Collection collectionType="seasons" onItemEnter={handleEnter} {...props} />;
};

const mapState = createStructuredSelector({
  data: selectSeasons,
  contentId: selectContentIdFromProps,
  contentType: selectContentTypeFromProps,
  isParentalEnabled: selectParentalControl,
  backButtonKeyCode: selectBackButtonKeyCode,
  collectionId: selectCollectionId,
  collectionTitle: selectCollectionTitle,
});

const mapDispatch = {
  fetchDetails,
  showModal,
  hideModal,
  navigateToPlayerPage,
  navigateToAuthPage,
  exit: () => Platform.exit(),
};

export default withKeepingLastFocus(connect(mapState, mapDispatch)(SeasonsPageContainer));
